import Cookies from 'js-cookie'

export function createUrlsParamBasedOnCookies() {
	const campain = Cookies.get('mutm_campaign')
	const medium = Cookies.get('mutm_medium')
	const source = Cookies.get('mutm_source')
	const term = Cookies.get('mutm_term')
	const content = Cookies.get('mutm_content')
	const fbclid = Cookies.get('mfbclid')
	const gclid = Cookies.get('mgclid')
	if (campain || medium || source) {
		let params = campain ? `&utm_campaign=${campain}` : ''
		params += medium ? `&utm_medium=${medium}` : ''
		params += source ? `&utm_source=${source}` : ''
		params += term ? `&utm_term=${term}` : ''
		params += content ? `&utm_content=${content}` : ''
		params += fbclid ? `&fbclid=${fbclid}` : ''
		params += gclid ? `&gclid=${gclid}` : ''
		return `?${params.slice(1)}`
	}
	return ''
}

export function redirectWithCookies(url) {
	const paramsCookie = createUrlsParamBasedOnCookies()
	var currentURL = window.location.href;

	Cookies.set('trial_page_ref', currentURL, { domain: '.mercos.com' });
	window.location = `${url}${paramsCookie}`
}



// WEBPACK FOOTER //
// /usr/src/site-blog/src/utils/Utm.js